import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { catchError, Observable, switchMap } from "rxjs";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { ROUTES } from "@app/shared/constants/routes.constants";
import { NodeJSAuthenticationInterceptor } from "@app/core/services/http/interceptors/node-js-authentication.interceptor";
import { Router } from "@angular/router";
import { AppInjector } from "@app/core/functions/app-injector";

/**
 * Transforms all ussi responses
 */
@Injectable({
  providedIn: "root"
})
export class NodeJSResponseInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((error) => this._errorHandler(error, request, next)));
  }

  /**
   * Handle JWT token errors
   * @param response
   */
  private _errorHandler(response: HttpEvent<any>, request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (response instanceof HttpErrorResponse) {
      if (response?.error?.message?.includes("jwt")) {
        return this.authService.nodeJsRefreshToken().pipe(
          switchMap(() => next.handle(this.nodeJsAuthInterceptor.addTokenHeader(request))),
          catchError((error) => {
            this.routeService.navigate([ROUTES.LOGIN]);
            throw error;
          })
        );
      }
    }

    throw response;
  }

  get authService() {
    return AppInjector.get(AuthenticationService);
  }

  get routeService() {
    return AppInjector.get(Router);
  }

  get nodeJsAuthInterceptor() {
    return new NodeJSAuthenticationInterceptor(false);
  }
}
